import { CalendarDays, Eye } from "lucide-react";
import { Link } from "react-router-dom";
import PodcastImg from "../../assets/images/PodcastVid.png";
import PodacastVideoBoxLoading from "../loading/podcast-video-box";
import { useTranslation } from "react-i18next";

export default function PodcastBoxVideo({ podcast, error, isLoading }) {
    const { t } = useTranslation();
    if (isLoading) return (
        <PodacastVideoBoxLoading />
    );

    if (error) return (
        <div className="my-3">
            <p>
                {error?.message}
            </p>
        </div>
    );

    return (
        <div className="flex items-center gap-4 max-lg:flex-col">
            <div className="w-60 h-48 max-lg:h-72 max-lg:w-full max-lg:my-2 rounded-lg">
                <img src={podcast?.image || PodcastImg} alt="podcast vid" className="object-contain rounded-lg h-full w-full" />
            </div>
            <div className="!text-start w-full">
                <div className="flex items-center justify-between w-full mb-2">
                    {
                        (podcast?.publish_date || podcast?.date) &&
                        <div className="flex items-center gap-2">
                            <span>
                                <CalendarDays size={20} color="white" fill="#7A7A7A" />
                            </span>
                            <span className="font-sans">
                                {/* DATE */}
                                {podcast?.publish_date || podcast?.date}
                            </span>
                        </div>
                    }

                    <Link to={`/podcasts/${podcast?.id}`} className="flex items-center gap-2">
                        <span className="text-primary-tw underline">
                            {t('podcasts.watch')}
                        </span>
                        <span>
                            <Eye size={20} color="white" fill="var(--primary-color)" />
                        </span>
                    </Link>
                </div>
                {/* podcast vid title */}
                {
                    podcast?.title &&
                    <p className="text-primary-tw font-semibold">
                        {podcast?.title}
                    </p>
                }
                {/* speaker */}
                {
                    podcast?.title &&
                    <p className="text-secondary-tw m-0">
                        {podcast.title.split(" | ")?.pop()}
                    </p>
                }
                {/* desc */}
                {
                    podcast?.description &&
                    <p className="text-semi-gray text-[14px]"
                        dangerouslySetInnerHTML={{
                            __html:
                                (podcast?.description
                                    && podcast?.description.replace(/(<([^>]+)>)/gi, "").slice(0, 100) +
                                    (podcast?.description?.replace(/(<([^>]+)>)/gi, "").length > 100 ? '...' : '')
                                )
                        }}
                    />
                }

            </div>
        </div>
    )
};
